import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Image, NavDropdown } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import userArrowIcon from "../../../assets/images/arrow-icon.svg";
import profileIcon from "../../../assets/icons/profile-icon.svg";

import { useUserProfile } from "../../../auth.user";
import { useUserCapabilities } from "../../../auth.capabilities";
import {
  adminMenuList,
  externalUserMenuList,
  internalUserMenuList,
} from "../Utils";

const AdminMenuList = () => {
  const { hasAdminRights, hasInternalUserRights, hasExternalUserRights, role } =
    useUserCapabilities();

  const { instance } = useMsal();

  const { name, profile, loading } = useUserProfile();

  const [userAvatar, setUserAvatar] = useState(profileIcon);
  const [userName, setUserName] = useState("");
  const isDefaultAvatar = userAvatar === profileIcon;

  const formatName = (name) => {
    const cleanedName = name.replace(/,\s*/g, " ").trim();
    const words = cleanedName.split(/\s+/);

    if (words.length > 2) {
      return `${words.slice(0, 2).join(" ")}...`;
    }

    return cleanedName;
  };

  const capitalizedRole = role
    ? role.charAt(0).toUpperCase() + role.slice(1).replace(/-/g, " ")
    : "";

  useEffect(() => {
    // Applay user name
    if (!loading && profile?.id && profile?.givenName && profile?.surname) {
      // From profile
      setUserName(`${profile.givenName} ${profile.surname}`);
    } else if (name) {
      // From MSAL
      setUserName(name);
    }

    // Apply avatar
    if (!loading && profile?.photoUrl) {
      // From user profile
      setUserAvatar(profile?.photoUrl);
    } else {
      // Default Icon
      setUserAvatar(profileIcon);
    }
  }, [loading, name]);

  const handleLogoutRedirect = (event) => {
    event.preventDefault();
    instance.logoutRedirect();
  };

  return (
    <NavDropdown
      title={
        <button className="user-info">
          {isDefaultAvatar ? (
            <span
              className="ellipse avatar-icon-mask"
              aria-hidden="true"
              style={{ "--icon-url": `url("${profileIcon}")` }}
            />
          ) : (
            <Image className="ellipse" src={userAvatar} alt="User" />
          )}

          <div className="user-details">
            <div className="user-name">{formatName(userName)}</div>
            <div className="user-role">{capitalizedRole}</div>
          </div>
          <img className="icon" src={userArrowIcon} alt="arrow" />
        </button>
      }
      id="basic-nav-dropdown"
      className="navbar-menu-dropdown"
    >
      {/* Admin Menu List */}
      {hasAdminRights &&
        adminMenuList.map((menuItem) => {
          return (
            <React.Fragment key={menuItem.path}>
              {menuItem.label === "Settings" && <NavDropdown.Divider />}
              <NavDropdown.Item
                as={NavLink}
                to={menuItem.path}
                className="nav-dropdown-link"
                onClick={
                  menuItem.label === "Sign out"
                    ? handleLogoutRedirect
                    : undefined
                }
              >
                <span className="menu-item-row">
                  <span
                    className="menu-item-icon-mask"
                    aria-hidden="true"
                    style={{ "--icon-url": `url("${menuItem.icon}")` }}
                  />
                  <span className="menu-item-label">{menuItem.label}</span>
                </span>
              </NavDropdown.Item>
            </React.Fragment>
          );
        })}
      {/* Internal User Menu List */}
      {hasInternalUserRights &&
        internalUserMenuList.map((menuItem) => {
          return (
            <React.Fragment key={menuItem.path}>
              {menuItem.label === "Settings" && <NavDropdown.Divider />}
              <NavDropdown.Item
                as={NavLink}
                to={menuItem.path}
                className="nav-dropdown-link"
                onClick={
                  menuItem.label === "Sign out"
                    ? handleLogoutRedirect
                    : undefined
                }
              >
                <span className="menu-item-row">
                  <span
                    className="menu-item-icon-mask"
                    aria-hidden="true"
                    style={{ "--icon-url": `url("${menuItem.icon}")` }}
                  />
                  <span className="menu-item-label">{menuItem.label}</span>
                </span>
              </NavDropdown.Item>
            </React.Fragment>
          );
        })}

      {/* External User Menu List */}
      {hasExternalUserRights &&
        externalUserMenuList.map((menuItem) => {
          return (
            <React.Fragment key={menuItem.path}>
              {menuItem.label === "Settings" && <NavDropdown.Divider />}
              <NavDropdown.Item
                as={NavLink}
                to={menuItem.path}
                className="nav-dropdown-link"
                onClick={
                  menuItem.label === "Sign out"
                    ? handleLogoutRedirect
                    : undefined
                }
              >
                <span className="menu-item-row">
                  <span
                    className="menu-item-icon-mask"
                    aria-hidden="true"
                    style={{ "--icon-url": `url("${menuItem.icon}")` }}
                  />
                  <span className="menu-item-label">{menuItem.label}</span>
                </span>
              </NavDropdown.Item>
            </React.Fragment>
          );
        })}
    </NavDropdown>
  );
};

export default AdminMenuList;
